export const ORDER_BY_NEWEST = 'orderByNewest' as const;
export const ORDER_BY_HIGHEST = 'orderByHighest' as const;
export const ORDER_BY_LOWEST = 'orderByLowest' as const;

export type OrderBy = typeof ORDER_BY_NEWEST | typeof ORDER_BY_HIGHEST | typeof ORDER_BY_LOWEST;
